import { injectGlobal } from "styled-components";

injectGlobal`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1;

    &::after {
        content: '';
        position: fixed;
        width: 100%;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        height:100%;
        // mix-blend-mode: soft-light;
        pointer-events: none;
        background: none;
        @media screen and (min-width: 50em) {
          max-width:864px;
          background: repeating-linear-gradient(
            to right,
            transparent 1px,
            #f3f6f5 2px,
            transparent 1px,
            transparent 33%
          );
      }

        @media screen and (min-width: 1440px) {
            max-width: 1440px;
            background: repeating-linear-gradient(
              to right,
              transparent 1px,
              #f3f6f5 2px,
              transparent 1px,
              transparent 20%
            );

           }

    }
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  * {
    box-sizing: border-box;
  }

  body {
    background: white;
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    font-variant-ligatures: none;
    -webkit-font-variant-ligatures: none;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
    font-weight: 400;
    font-family: 'Roboto', sans-serif;
  }

  h1, h2, h3, h4, h5 {
      font-family: 'Quicksand', sans-serif;
  }

  img {
    display: block;
  	width: 100%;
  	height: auto;
  }
  
  a.activeLinkStyle, button.activeLinkStyle {
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background: white;
      left: 0;
      top: 52px;
      
      @media (min-width: 800px) {
        top: 28px;
      }
    }
  }
  
  button.activeLinkStyle {
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background: white;
      left: 0;
      top: 35px;
      
      @media (min-width: 800px) {
        top: 28px;
      }
    }
  }
  
  .sr-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js